import React from 'react'

const POSITIVE_DATA = [10, 20, 20, 10, 9, 29, 26, 26, 17, 22, 26, 22]
const NEGATIVE_DATA = [15, 11, 24, 9, 19, 19, 13, 23, 14, 23, 28, 25]

export const PortfolioGainLossMiniChart: React.FC = () => {
  const width = 185
  const height = 124
  const barWidth = 12.12
  const gap = 3.59
  const baselineY = 62
  const startX = 0
  const redIndex = 6

  return (
    <div className="absolute right-0 top-0 h-[124px] w-[185px] overflow-hidden">
      <svg className="h-full w-full" viewBox={`0 0 ${width} ${height}`} fill="none" xmlns="http://www.w3.org/2000/svg">
        {POSITIVE_DATA.map((value, index) => {
          const x = startX + index * (barWidth + gap)
          return (
            <rect
              key={`top-${index}`}
              x={x}
              y={baselineY - value}
              width={barWidth}
              height={value}
              rx={2}
              fill="#b8e995"
              fillOpacity="0.9"
            />
          )
        })}

        <line x1="0" y1={baselineY + 1} x2={width} y2={baselineY + 1} stroke="rgba(45,41,35,0.32)" strokeWidth="1" />

        {NEGATIVE_DATA.map((value, index) => {
          const x = startX + index * (barWidth + gap)
          const isRed = index === redIndex
          return (
            <rect
              key={`bottom-${index}`}
              x={x}
              y={baselineY + 2}
              width={barWidth}
              height={value}
              rx={2}
              fill={isRed ? '#e5907f' : '#efefef'}
              fillOpacity={isRed ? 1 : 0.72}
            />
          )
        })}
      </svg>
    </div>
  )
}

export default PortfolioGainLossMiniChart
